import { render, staticRenderFns } from "./userInfo_IndividualPapersDetail.vue?vue&type=template&id=1c91d10c&scoped=true&"
import script from "./userInfo_IndividualPapersDetail.vue?vue&type=script&lang=js&"
export * from "./userInfo_IndividualPapersDetail.vue?vue&type=script&lang=js&"
import style0 from "./userInfo_IndividualPapersDetail.vue?vue&type=style&index=0&id=1c91d10c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91d10c",
  null
  
)

export default component.exports